import React from "react"

function IconSpeakerSlashMono({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="speaker-slash-mono"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-speaker-slash-mono"
      {...props}
    >
      <path
        d="m3.627 3.268.093.073 17.455 16.363a.655.655 0 0 1-.802 1.028l-.093-.073L2.825 4.296a.655.655 0 0 1 .802-1.028zM5.492 8.29 6.888 9.6H4.364v5.018H7.2V9.892l1.31 1.228v4.107l5.563 3.709v-2.6l1.309 1.228v2.391a.764.764 0 0 1-1.187.635L7.2 15.927H4.145a1.09 1.09 0 0 1-1.09-1.09V9.381c0-.603.488-1.091 1.09-1.091h1.347zM19.746 7.25a6.474 6.474 0 0 1 .036 9.653l-.954-.894.031-.035.035-.033a5.164 5.164 0 0 0-.018-7.714.655.655 0 1 1 .87-.977zm-2.075 2.427a3.122 3.122 0 0 1 .01 4.82.652.652 0 0 1-.313.142l-.757-.707a.652.652 0 0 1 .233-.442 1.813 1.813 0 0 0-.007-2.803.655.655 0 0 1 .834-1.01zM15.254 3.84a.764.764 0 0 1 .128.423v8.515l-1.31-1.228V5.281l-3.908 2.605-.98-.918 5.01-3.34a.764.764 0 0 1 1.06.212z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconSpeakerSlashMono
